import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { LayerContextEnum } from '../../../../enuns/layerContext.enum';

interface textValue {
    text: string;
    value: string | number;
}

interface filterItem {
    name: string;
    position: number;
    fields: filterFieldItem[]
}

interface filterFieldItem {
    title: string;
    name: string;
    dataSource: textValue[];
    value: string;
    text: string;
    skipAll: true,
    type: string;
}

export class FuelStationFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData(): filterItem[] {
        const isAuthorized = permission => api.authorization.isAuthorized(permission);

        const source = environment.get('CONFIG.FILTERS.FUEL_STATION_BRANDS')
            .map(x => {
                if (isAuthorized(FeaturePermission.LAYER_GENERAL.filterFuelType) && x.idLayerContext === LayerContextEnum.FuelStation) {
                    return x;
                }

                if (isAuthorized(FeaturePermission.LAYER_GENERAL.filterEletricType) && x.idLayerContext === LayerContextEnum.EletricStation) {
                    return x;
                }

                return null;
            })
            .filter(x => x != null);

        let filters = [
            {
                name: 'fuelstation_groups',
                position: 1,
                data: source,
                fields: [
                    {
                        title: translate('Common.Type'),
                        name: 'contexts',
                        text: 'layerContextName',
                        value: 'idLayerContext',
                        type: 'dropdown',
                    }
                ]
            }
        ];

        if (isAuthorized(FeaturePermission.LAYER_GENERAL.filterEletricType) && source.filter(x => x.idLayerContext !== LayerContextEnum.EletricStation).length) {
            filters[0].fields.push({
                title: translate('Common.Brand'),
                name: 'brands',
                text: 'brandName',
                value: 'idBrand',
                type: 'multiselect',
                skipAll: true,
            });
        }

        const fuelStationTypes = [
            { name: 'Leves', value: "Leve" },
            { name: 'Pesados', value: "Pesado" },
        ];

        if (source.filter(x => x.idLayerContext !== LayerContextEnum.EletricStation).length) {
            filters.push({
                name: 'fuelStationTypes',
                position: 3,
                data: fuelStationTypes,
                fields: [
                    {
                        title: 'Tipo Posto Combustível',
                        name: 'fuelStationTypes',
                        text: 'name',
                        value: 'value',
                        type: 'multiselect',
                    }
                ]
            });
        }

        return filters;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/fuelStation.factory.js